"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpkClient = void 0;
const stream_tile_1 = require("@ceramicnetwork/stream-tile");
const idx_1 = require("@ceramicstudio/idx");
const config_service_1 = require("./config.service");
const spk_indexer_api_service_1 = require("./spk-indexer-api.service");
const base64url_1 = __importDefault(require("base64url"));
const random_1 = require("@stablelib/random");
const constants_1 = require("./common/constants");
const _1 = require(".");
class SpkClient {
    constructor(spkIndexerHost, ceramic) {
        this.spkIndexerHost = spkIndexerHost;
        this.ceramic = ceramic;
        this.apiClient = new spk_indexer_api_service_1.SpkIndexerApi(spkIndexerHost);
        this.idx = new idx_1.IDX({
            autopin: true,
            ceramic: ceramic,
            aliases: config_service_1.ConfigService.getConfig().idxAliases,
        });
    }
    updateDocument(streamId, content) {
        return __awaiter(this, void 0, void 0, function* () {
            let doc;
            try {
                doc = yield stream_tile_1.TileDocument.load(this.ceramic, streamId);
            }
            catch (err) {
                console.error(`Could not load doc id '${streamId}' for update: `, err.message);
                throw err;
            }
            yield doc.update(Object.assign(Object.assign({}, doc.content), { updated_at: new Date().toISOString(), content: content }), undefined, { anchor: true });
            yield this.apiClient.requestDocumentReindex(streamId);
        });
    }
    fetchDocument(documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.getDocument(documentId);
        });
    }
    getDocumentsForUser(userId, sort = _1.DocSortOption.createddesc, page = 1, pageSize = 25) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.apiClient.getDocsForUser(userId, sort, page, pageSize);
            }
            catch (err) {
                console.error(`Error getting docs for user!`, err);
                throw err;
            }
        });
    }
    getDocumentChildren(parentDocId, sort = _1.DocSortOption.createddesc, page = 1, pageSize = 25) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.getDocChildren(parentDocId, sort, page, pageSize);
        });
    }
    requestDocInitialIndex(streamId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.apiClient.requestDocumentFirstIndex(streamId);
            }
            catch (err) {
                console.error(`Error requesting document reindex on spk indexer daemon! ${err.message}`);
                throw err;
            }
        });
    }
    getFeedDocs(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.getFeedDocs(options === null || options === void 0 ? void 0 : options.page, options === null || options === void 0 ? void 0 : options.pageSize);
        });
    }
    get loggedInDid() {
        var _a, _b;
        if (!((_a = this.ceramic.did) === null || _a === void 0 ? void 0 : _a.id))
            throw new Error(`User not logged in, could not retrieve DID`);
        return (_b = this.ceramic.did) === null || _b === void 0 ? void 0 : _b.id;
    }
    createDocument(content, parentId = undefined) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const creatorId = (_a = this.ceramic.did) === null || _a === void 0 ? void 0 : _a.id;
            if (!creatorId) {
                throw new Error(`User not authenticated with ceramic`);
            }
            const now = new Date();
            const doc = yield stream_tile_1.TileDocument.create(this.ceramic, {
                parent_id: parentId,
                content,
                created_at: now.toISOString(),
                updated_at: now.toISOString(),
            }, { tags: ['spk_network'], controllers: [creatorId] }, { anchor: true, publish: false });
            // TODO: restrict this to parent docs only once corresponding backend features are ready
            try {
                yield this.recordDocToRootPosts(doc.id.toString(), creatorId);
            }
            catch (err) {
                console.error(`Error recording doc to root posts!`, err.message);
                throw err;
            }
            yield this.requestDocInitialIndex(doc.id.toString());
            return {
                creatorId: creatorId,
                streamId: doc.id.toString(),
                parentId: doc.content.parent_id,
                content: doc.content.content,
                createdAt: doc.content.created_at,
                updatedAt: doc.content.updated_at,
            };
        });
    }
    recordDocToRootPosts(streamIdUrl, userDid) {
        return __awaiter(this, void 0, void 0, function* () {
            const permlink = base64url_1.default.encode((0, random_1.randomBytes)(6).buffer);
            let rootDocs = (yield this.idx.get(constants_1.IDX_ROOT_DOCS_KEY, userDid));
            if (rootDocs) {
                rootDocs[permlink] = streamIdUrl;
            }
            else {
                rootDocs = {
                    [permlink]: streamIdUrl,
                };
            }
            yield this.idx.set(constants_1.IDX_ROOT_DOCS_KEY, rootDocs);
        });
    }
}
exports.SpkClient = SpkClient;
